.g-global-nav-main
  ul.g-global-nav
    each navItem in navItems
      li.g-global-nav-li
        a.g-nav-link(g-target=navItem.target, g-name=navItem.name, href=`#${navItem.target}`)
          i(class=navItem.icon)
          span= navItem.name
